import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_APPLICATION_OWNER,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
  CAMPAIGNTYPE_SERVICEACCOUNT,
  CAMPAIGNTYPE_USERMANAGER,
} from '../../utils/constant';
import {
  SIDE_PANEL_CATEGORY_ACC,
  SIDE_PANEL_CATEGORY_ENT,
  SIDE_PANEL_CATEGORY_RLE,
  SIDE_PANEL_CATEGORY_USR,
} from '../CertsDetails/CertsSidePanel';

import { deepClone } from './utils';

export const TRANSITION_TIMEOUT = 500;
export const MIN_BTN_TO_SHOW_FOR_BULK_ACTION_FOOTER = 1;
export const MAX_BTN_TO_SHOW_FOR_BULK_ACTION_FOOTER = 3;
export const SCREEN_WIDTH_FOR_BUTTONS_TO_SHOW_1 = 427;
export const SCREEN_WIDTH_FOR_BUTTONS_TO_SHOW_2 = 600;
export const COMMENT_MINIMUM_LENGTH = 2;
export const BULK_ACTION_CATEGORY_USR = SIDE_PANEL_CATEGORY_USR;
export const BULK_ACTION_CATEGORY_RLE = SIDE_PANEL_CATEGORY_RLE;
export const BULK_ACTION_CATEGORY_ACC = SIDE_PANEL_CATEGORY_ACC;
export const BULK_ACTION_CATEGORY_ENT = SIDE_PANEL_CATEGORY_ENT;
export const BULK_ACTION_BUTTON_COUNT_PER_ROW = 4;

export const BULK_ACTION_OBJ_USERS = 'totalUsers';
export const BULK_ACTION_OBJ_ROLES = 'totalRoles';
export const BULK_ACTION_OBJ_ACCOUNTS = 'totalAccounts';
export const BULK_ACTION_OBJ_ENTITLEMENTS = 'totalEntitlements';
export const BULK_ACTION_OBJ_PARENT_ENTITLEMENTS = 'totalParentEntitlements';
export const BULK_ACTION_OBJ_CHILD_ENTITLEMENTS = 'totalChildEntitlements';
export const BULK_ACTION_OBJ_TOTAL = 'totalSelectedItems';

export const BULK_ACTION_IDS = {
  DECOMMISSION: 'decommission',
  DOES_NOT_WORK_FOR_ME: 'doesNotWorksForMe',
};

export const DEFAULT_BULK_ACTION_FOOTER_BTNS = {
  CLEAR: {
    id: 'bulkActionClearBtn',
    icon: 'clear',
    status: '-1',
    text: 'CERTS_BULK_CLEAR_SELECTION',
    objectsToTotal: [],
  },
  WORKS_FOR_ME: {
    id: 'worksForMe',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_WORKS_FOR_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_USERS,
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  DOES_NOT_WORK_FOR_ME: {
    id: 'doesNotWorksForMe',
    icon: 'reassignUser',
    status: '3',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  DOES_NOT_BELONG_TO_ME: {
    id: 'doesNotBelongToMe',
    icon: 'reassignUser',
    status: '3',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [BULK_ACTION_OBJ_ACCOUNTS],
  },
  TERMINATE: {
    id: 'terminated',
    icon: 'terminate',
    status: '4',
    text: 'CERTS_BULK_TERMINATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  EXTEND_END_DATE: {
    id: 'extendEndDate',
    icon: 'ExtendEndDate',
    status: '2',
    text: 'CERTS_BULK_EXTEND_END_DATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  APPROVE: {
    id: 'approve',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_APPROVE',
    objectsToTotal: [],
  },
  REJECT: {
    id: 'reject',
    icon: 'reject',
    status: '3',
    text: 'CERTS_BULK_REJECT',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  CONDITIONAL_CERTIFIY: {
    id: 'conditionalCertifiy',
    icon: 'ExtendEndDate',
    status: '5',
    text: 'CERTS_BULK_CONDITIONAL_CERTIFIY',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  REASSIGN: {
    id: 'reassign',
    icon: 'reassignItem',
    status: '-1',
    text: 'CERTS_BULK_REASSIGN',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  CONSULT: {
    id: 'consult',
    icon: 'Consult',
    status: '-1',
    text: 'CERTS_BULK_CONSULT',
    objectsToTotal: [],
  },
  DECOMMISSION: {
    id: 'decommission',
    icon: 'HelpFilled',
    status: '0',
    text: 'CERTS_BULK_DECOMMISSION',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  BELONGS_TO_ME: {
    id: 'belongsToMe',
    icon: 'approve',
    status: '1',
    text: 'CERTS_BULK_BELONGS_TO_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
};

export const AO_BULK_ACTION_FOOTER_BTNS = {
  CLEAR: {
    id: 'bulkActionClearBtn',
    icon: 'clear',
    status: '-1',
    text: 'CERTS_BULK_CLEAR_SELECTION',
    objectsToTotal: [],
  },
  WORKS_FOR_ME: {
    id: 'worksForMe',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_WORKS_FOR_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_USERS,
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  DOES_NOT_WORK_FOR_ME: {
    id: 'doesNotWorksForMe',
    icon: 'reassignUser',
    status: '3',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  DOES_NOT_BELONG_TO_ME: {
    id: 'doesNotBelongToMe',
    icon: 'reassignUser',
    status: '3',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [BULK_ACTION_OBJ_ACCOUNTS],
  },
  TERMINATE: {
    id: 'terminated',
    icon: 'terminate',
    status: '4',
    text: 'CERTS_BULK_TERMINATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  EXTEND_END_DATE: {
    id: 'extendEndDate',
    icon: 'ExtendEndDate',
    status: '2',
    text: 'CERTS_BULK_EXTEND_END_DATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  APPROVE: {
    id: 'approve',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_APPROVE',
    objectsToTotal: [
      BULK_ACTION_OBJ_USERS,
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  REJECT: {
    id: 'reject',
    icon: 'reject',
    status: '3',
    text: 'Reject.Default.label.ATTESTATIONS',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  CONDITIONAL_CERTIFIY: {
    id: 'conditionalCertifiy',
    icon: 'ExtendEndDate',
    status: '5',
    text: 'CERTS_BULK_CONDITIONAL_CERTIFIY',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  REASSIGN: {
    id: 'reassign',
    icon: 'reassignItem',
    status: '-1',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  CONSULT: {
    id: 'consult',
    icon: 'Consult',
    status: '-1',
    text: 'CERTS_BULK_CONSULT',
    objectsToTotal: [],
  },
  DECOMMISSION: {
    id: 'decommission',
    icon: 'HelpFilled',
    status: '0',
    text: 'CERTS_BULK_DECOMMISSION',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  BELONGS_TO_ME: {
    id: 'belongsToMe',
    icon: 'approve',
    status: '1',
    text: 'CERTS_BULK_BELONGS_TO_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
};
export const SA_BULK_ACTION_FOOTER_BTNS = {
  CLEAR: {
    id: 'bulkActionClearBtn',
    icon: 'clear',
    status: '-1',
    text: 'CERTS_BULK_CLEAR_SELECTION',
    objectsToTotal: [],
  },
  WORKS_FOR_ME: {
    id: 'worksForMe',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_WORKS_FOR_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
    ],
  },
  DOES_NOT_WORK_FOR_ME: {
    id: 'doesNotWorksForMe',
    icon: 'reassignUser',
    status: '3',
    text: 'CERTS_BULK_DOES_NOT_WORK_FOR_ME',
    objectsToTotal: [BULK_ACTION_OBJ_ACCOUNTS],
  },
  DOES_NOT_BELONG_TO_ME: {
    id: 'doesNotBelongToMe',
    icon: 'reassignUser',
    status: '3',
    text: 'Certs.ReassignAccount.Label',
    objectsToTotal: [BULK_ACTION_OBJ_ACCOUNTS],
  },
  TERMINATE: {
    id: 'terminated',
    icon: 'terminate',
    status: '4',
    text: 'CERTS_BULK_TERMINATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  EXTEND_END_DATE: {
    id: 'extendEndDate',
    icon: 'ExtendEndDate',
    status: '2',
    text: 'CERTS_BULK_EXTEND_END_DATE',
    objectsToTotal: [BULK_ACTION_OBJ_USERS],
  },
  APPROVE: {
    id: 'approve',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_APPROVE',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
    ],
  },
  REJECT: {
    id: 'reject',
    icon: 'reject',
    status: '3',
    text: 'Reject.Default.label.ATTESTATIONS',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
    ],
  },
  CONDITIONAL_CERTIFIY: {
    id: 'conditionalCertifiy',
    icon: 'ExtendEndDate',
    status: '5',
    text: 'CERTS_BULK_CONDITIONAL_CERTIFIY',
    objectsToTotal: [BULK_ACTION_OBJ_ROLES, BULK_ACTION_OBJ_ENTITLEMENTS],
  },
  REASSIGN: {
    id: 'reassign',
    icon: 'reassignItem',
    status: '-1',
    text: 'CERTS_BULK_REASSIGN',
    objectsToTotal: [BULK_ACTION_OBJ_ROLES, BULK_ACTION_OBJ_ENTITLEMENTS],
  },
  CONSULT: {
    id: 'consult',
    icon: 'Consult',
    status: '-1',
    text: 'CERTS_BULK_CONSULT',
    objectsToTotal: [],
  },
  DECOMMISSION: {
    id: 'decommission',
    icon: 'HelpFilled',
    status: '0',
    text: 'CERTS_BULK_DECOMMISSION',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
  BELONGS_TO_ME: {
    id: 'belongsToMe',
    icon: 'approve',
    status: '1',
    text: 'CERTS_BULK_BELONGS_TO_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_ROLES,
      BULK_ACTION_OBJ_ENTITLEMENTS,
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
    ],
  },
};
export const EO_BULK_ACTION_FOOTER_BTNS = {
  CLEAR: {
    id: 'bulkActionClearBtn',
    icon: 'clear',
    status: '-1',
    text: 'CERTS_BULK_CLEAR_SELECTION',
    objectsToTotal: [],
  },
  WORKS_FOR_ME: {
    id: 'worksForMe',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_WORKS_FOR_ME',
    objectsToTotal: [
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_CHILD_ENTITLEMENTS,
    ],
  },
  DOES_NOT_WORK_FOR_ME: {
    id: 'doesNotWorksForMe',
    icon: 'reassignUser',
    status: '4',
    text: 'Certs.ReassignEntitlement.Label',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
  DOES_NOT_BELONG_TO_ME: {
    id: 'doesNotBelongToMe',
    icon: 'reassignUser',
    status: '4',
    text: 'Certs.ReassignEntitlement.Label',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
  TERMINATE: {
    id: 'terminated',
    icon: 'terminate',
    status: '4',
    text: 'CERTS_BULK_TERMINATE',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
  EXTEND_END_DATE: {
    id: 'extendEndDate',
    icon: 'ExtendEndDate',
    status: '2',
    text: 'CERTS_BULK_EXTEND_END_DATE',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
  APPROVE: {
    id: 'approve',
    icon: 'Check',
    status: '2',
    text: 'CERTS_BULK_APPROVE',
    objectsToTotal: [
      BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_CHILD_ENTITLEMENTS,
    ],
  },
  REJECT: {
    id: 'reject',
    icon: 'reject',
    status: '3',
    text: 'Reject.Default.label.ATTESTATIONS',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_CHILD_ENTITLEMENTS,
    ],
  },
  CONDITIONAL_CERTIFIY: {
    id: 'conditionalCertifiy',
    icon: 'ExtendEndDate',
    status: '5',
    text: 'CERTS_BULK_CONDITIONAL_CERTIFIY',
    objectsToTotal: [BULK_ACTION_OBJ_ACCOUNTS],
  },
  REASSIGN: {
    id: 'reassign',
    icon: 'reassignItem',
    status: '-1',
    text: 'CERTS_BULK_REASSIGN',
    objectsToTotal: [
      BULK_ACTION_OBJ_ACCOUNTS,
      BULK_ACTION_OBJ_CHILD_ENTITLEMENTS,
    ],
  },
  CONSULT: {
    id: 'consult',
    icon: 'Consult',
    status: '-1',
    text: 'CERTS_BULK_CONSULT',
    objectsToTotal: [],
  },
  DECOMMISSION: {
    id: 'decommission',
    icon: 'HelpFilled',
    status: '0',
    text: 'CERTS_BULK_DECOMMISSION',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
  BELONGS_TO_ME: {
    id: 'belongsToMe',
    icon: 'approve',
    status: '1',
    text: 'CERTS_BULK_BELONGS_TO_ME',
    objectsToTotal: [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS],
  },
};

// to get the bulk footer actions for different campaigns
export const getBulkActionFooterBtns = (campaignType, reassignConfigMap) => {
  const campaignName = CAMPAIGN_TYPES[campaignType];

  let footerBtns = deepClone(DEFAULT_BULK_ACTION_FOOTER_BTNS);

  switch (campaignName) {
    case CAMPAIGNTYPE_ENTITLEMENTOWNER:
      footerBtns = deepClone(EO_BULK_ACTION_FOOTER_BTNS);
      // to include consult count for Parent Ent and Accounts
      footerBtns.CONSULT.objectsToTotal = [];

      if (reassignConfigMap.showConsultStep1)
        footerBtns.CONSULT.objectsToTotal.push(
          BULK_ACTION_OBJ_PARENT_ENTITLEMENTS
        );

      if (reassignConfigMap.showConsultStep2)
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ACCOUNTS);

      break;
    case CAMPAIGNTYPE_SERVICEACCOUNT:
      footerBtns = deepClone(SA_BULK_ACTION_FOOTER_BTNS);

      if (reassignConfigMap.showConsultStep1)
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ACCOUNTS);

      if (reassignConfigMap.showConsultStep2) {
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ROLES);
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ENTITLEMENTS);
      }

      break;
    case CAMPAIGNTYPE_APPLICATION_OWNER:
      footerBtns = deepClone(AO_BULK_ACTION_FOOTER_BTNS);

      if (reassignConfigMap.showConsultStep2) {
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ACCOUNTS);
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ROLES);
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ENTITLEMENTS);
      }

      break;
    case CAMPAIGNTYPE_USERMANAGER:
      // To check the approve is configured for User lineitem
      if (reassignConfigMap?.SHOWEMPLOYEESTATUSOPTIONINSTEP1?.includes('2')) {
        footerBtns.APPROVE.objectsToTotal.push(BULK_ACTION_OBJ_USERS);
      }

      footerBtns.APPROVE.objectsToTotal.push(BULK_ACTION_OBJ_ACCOUNTS);
      footerBtns.APPROVE.objectsToTotal.push(BULK_ACTION_OBJ_ROLES);
      footerBtns.APPROVE.objectsToTotal.push(BULK_ACTION_OBJ_ENTITLEMENTS);

      if (reassignConfigMap.showConsultStep1)
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_USERS);

      if (reassignConfigMap.showConsultStep2) {
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ACCOUNTS);
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ROLES);
        footerBtns.CONSULT.objectsToTotal.push(BULK_ACTION_OBJ_ENTITLEMENTS);
      }

      break;
    default:
      break;
  }

  return footerBtns;
};

export const DEFAULT_BULK_ACTION_COMMON_ACTION_PREFIX = {
  [DEFAULT_BULK_ACTION_FOOTER_BTNS.APPROVE.id]:
    'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
  [DEFAULT_BULK_ACTION_FOOTER_BTNS.WORKS_FOR_ME.id]:
    'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
  [DEFAULT_BULK_ACTION_FOOTER_BTNS.REJECT.id]:
    'CERTS_BULK_COMMON_SUB_PRE_REJECT',
  [DEFAULT_BULK_ACTION_FOOTER_BTNS.TERMINATE.id]:
    'CERTS_BULK_COMMON_SUB_PRE_TERMINATE',
};

export const EO_BULK_ACTION_COMMON_ACTION_PREFIX = {
  [EO_BULK_ACTION_FOOTER_BTNS.APPROVE.id]: 'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
  [EO_BULK_ACTION_FOOTER_BTNS.WORKS_FOR_ME.id]:
    'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
  [EO_BULK_ACTION_FOOTER_BTNS.REJECT.id]: 'CERTS_BULK_COMMON_SUB_PRE_REJECT',
  [EO_BULK_ACTION_FOOTER_BTNS.TERMINATE.id]:
    'CERTS_BULK_COMMON_SUB_PRE_TERMINATE',
  [EO_BULK_ACTION_FOOTER_BTNS.BELONGS_TO_ME.id]:
    'CERTS_BULK_COMMON_SUB_PRE_APPROVE',
  [EO_BULK_ACTION_FOOTER_BTNS.DECOMMISSION.id]:
    'CERTS_BULK_COMMON_SUB_PRE_DECOMMISSION',
};

export const BULK_ACTION_FOOTER_BTNS_REVERSE = {
  worksForMe: 'WORKS_FOR_ME',
  doesNotWorksForMe: 'DOES_NOT_WORK_FOR_ME',
  doesNotBelongToMe: 'DOES_NOT_BELONG_TO_ME',
  terminated: 'TERMINATE',
  extendEndDate: 'EXTEND_END_DATE',
  approve: 'APPROVE',
  reject: 'REJECT',
  conditionalCertifiy: 'CONDITIONAL_CERTIFIY',
  reassign: 'REASSIGN',
  consult: 'CONSULT',
  decommission: 'DECOMMISSION',
  belongsToMe: 'BELONGS_TO_ME',
};

export const BULK_ACTION_FOOTER_OBJECTS = {
  [BULK_ACTION_OBJ_USERS]: 'User',
  [BULK_ACTION_OBJ_ACCOUNTS]: 'Account',
  [BULK_ACTION_OBJ_ROLES]: 'Role',
  [BULK_ACTION_OBJ_ENTITLEMENTS]: 'Entitlement',
  [BULK_ACTION_OBJ_PARENT_ENTITLEMENTS]: 'ParentEntitlement',
  [BULK_ACTION_OBJ_CHILD_ENTITLEMENTS]: 'ChildEntitlement',
};

export const BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS = {
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_USERS]]: 'CERTS_BULK_USER',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_USERS]}s`]:
    'CERTS_BULK_USERS',
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ACCOUNTS]]:
    'CERTS_BULK_ACCOUNT',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ACCOUNTS]}s`]:
    'CERTS_BULK_ACCOUNTS',
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ROLES]]: 'CERTS_BULK_ROLE',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ROLES]}s`]:
    'CERTS_BULK_ROLES',
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ENTITLEMENTS]]:
    'CERTS_BULK_ENTITLEMENT',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_ENTITLEMENTS]}s`]:
    'CERTS_BULK_ENTITLEMENTS',
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_PARENT_ENTITLEMENTS]]:
    'CERTS_BULK_PARENT_ENTITLEMENT',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_PARENT_ENTITLEMENTS]}s`]:
    'CERTS_BULK_PARENT_ENTITLEMENTS',
  [BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_CHILD_ENTITLEMENTS]]:
    'CERTS_BULK_CHILD_ENTITLEMENT',
  [`${BULK_ACTION_FOOTER_OBJECTS?.[BULK_ACTION_OBJ_CHILD_ENTITLEMENTS]}s`]:
    'CERTS_BULK_CHILD_ENTITLEMENTS',
};

export const DEFAULT_OBJECT_FOR_COMMON_ACTION = {
  id: '',
  isOpen: false,
  showAlert: false,
  hasAgreed: false,
  isSubmitting: false,
  comment: '',
};

export const DEFAULT_OBJECT_FOR_END_DATE = {
  id: '',
  isOpen: false,
  showAlert: false,
  hasAgreed: false,
  isSubmitting: false,
  endDate: null,
  comment: '',
};

export const DEFAULT_OBJECT_FOR_CONSULT = {
  id: '',
  isOpen: false,
  showAlert: false,
  hasAgreed: false,
  isSubmitting: false,
  reassignAssociated: false,
  consultWith: '',
  consultWithName: '',
  comment: '',
};

export const DEFAULT_OBJECT_FOR_REASSIGN = {
  id: '',
  isOpen: false,
  showAlert: false,
  hasAgreed: false,
  isSubmitting: false,
  reassignAssociated: false,
  isSkipCertifier: false,
  reassignTo: '',
  reassignToName: '',
  comment: '',
  // isUpdateOwner: false,
};
